/* eslint-disable react/prop-types */
// @flow

// Standard Pakete
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import { hot } from 'react-hot-loader'

// hinzugefügte Pakete
import Masthead from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import ShareButtons, { displayTypes } from '@ta-interaktiv/react-share-buttons'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import Waypoint from 'react-waypoint'

// CSS
import 'styles/App.css'
import './style.scss'

type Props = {
  articleId: string
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '27167409',
    questions: [
      'Recherche: Der Flash kommt per A-Post',
      'Interview mit einem Darknet-Händler'
    ]
  }

  constructor (props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackNavClicks (e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks (e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render () {
    return (
      <div className='index'>
        <Masthead inverted articleID={this.props.articleId} />
        <header className='ui vertical fitted segment first'>
          <Cover
            title='«Ich würde es wieder tun»'
            subtitle='Die Affäre Meili – eine Chronologie'
          />
        </header>

        {/* Lead */}
        <div
          className='ui vertical fitted inverted segment dark-grey background'
          id='nav'
        >
          <div className='ui text container'>
            <p className='ta lead'>
              Vor 21 Jahren tobte in der Schweiz eine Staatskrise um die Erben
              nachrichtenloser Vermögen. Mittendrin machte Wachmann Christoph
              Meili seinen spektakulären Fund. Wie geht es den Protagonisten der
              Affäre heute? Ein Dok-Film hat alle aufgespürt – wir zeigen
              exklusiv erste Auszüge.
            </p>
            <p className='ta author'>Gila Blau und Interaktiv-Team</p>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'startReading'
                  })
                }
              }}
            />

            <p>
              Der 8. Januar 1997 war für Christoph Meili ein Arbeitstag wie
              jeder andere. Der 29-jährige gelernte Computer-Verkäufer begann im
              Auftrag der Sicherheitsfirma, bei der er angestellt war, seine
              abendlichen Runden im Hauptsitz der Grossbank UBS an der Zürcher
              Bahnhofstrasse. Zu jenem Zeitpunkt hiess sie noch Schweizerische
              Bankgesellschaft (SBG). Die Fusion mit dem Schweizerischen
              Bankverein zur Union Bank of Switzerland (UBS) kam erst genau 11
              Monate später, am 8. Dezember 1997, zustande.
            </p>
            <h4>Licht am falschen Ort</h4>
            <p>
              Die Kontrollrunden durch die Wachleute waren vorgeschrieben. Doch
              Meili sah an jenem Abend im Keller Licht im Schredder-Raum, wo
              keines sein sollte, und er ging hin, um es auszuknipsen.
            </p>
            <p>
              Beim Schredder und in Containern sah der Wachmann zu seiner
              Überraschung altmodische Bücher, breite, längliche Konto-Kladden,
              wie sie früher gebräuchlich waren, um handschriftlich die
              Geschäftsvorgänge zu notieren ... Herausgelöste Seiten von einigen
              Büchern lagen noch neben dem Reisswolf. Neugierig geworden,
              schaute Meili die länglichen Seiten an und fand darauf Daten der
              Eidgenössischen Bank Eiba aus den Dreissigerjahren, lauter
              Immobilien-Deals, meist aus Berlin.
            </p>
            <p>
              Der Wachmann wurde stutzig. Er wusste, dass es seit einigen Wochen
              einen Bundesbeschluss gab, der das Wegwerfen von Dokumenten aus
              den Dreissiger- und Vierzigerjahren verbot. Meili empfand ein
              moralisches Problem. Kurzentschlossen packte er die paar noch
              neben dem Reisswolf liegenden Bände und losen Seiten ein und nahm
              sie bei Dienstschluss mit nach Hause.
            </p>
            <p>
              Zuvor suchte Meili noch die (kürzlich verstorbene) Gertrud
              Erismann auf, die einflussreiche Sprecherin der Bank, die wie
              immer Überstunden schob. Er fragte sie, was wäre, wenn die Bank
              Dokumente aus der NS-Zeit hätte? Und ob man sie dann nicht publik
              machen sollte? Erismann wimmelte ihn ab. Ums Himmels willen, Herr
              Meili, sagte sie, das wäre ganz verkehrt. Die Presse würde über
              uns herfallen!
            </p>
            <h4>Der Whistleblower</h4>
            <p>
              Daheim in Rütihof schliefen die beiden kleinen Kinder schon
              längst. Zusammen mit seiner damaligen Ehefrau Giuseppina schaute
              Meili seinen Fund genauer an. «Eigentlich sollten wir das alles
              fotokopieren», fand das Ehepaar. Doch in der Haushaltskasse gab es
              nicht genug Geld für einen Besuch in einem Kopiershop.
            </p>
            <aside
              className='ui vertical very fitted segment widescreen hidden large screen hidden small'
              style={{ marginBottom: '1em' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>
                    «Affäre Meili – Ein Whistleblower zwischen Moral und
                    Milliarden»
                  </strong>
                  <br />
                  Ein brisanter Aktenfund macht aus einem Wachmann einen
                  Whistleblower, aus einem Sonderbotschafter einen TV-Star und
                  reisst ein neutrales Land in eine Staatsaffäre. Der von Daniel
                  von Aarburg realisierte Dokumentarfilm feiert Mitte August
                  Premiere.
                  <ul>
                    <li>
                      16. August 2018, 20 Uhr, Premiere und Debatte gibt es auch kostenlos im Livestream. <a href='https://www.offenerechnungen.ch/events-livestream'>Zur Anmeldung</a>
                    </li>
                    <li>
                      21. August 2018, 19.30 Uhr, Kino Kosmos, Zürich. Anschliessend Streitgespräch mit Christoph Blocher und Jakob Tanner. Moderation: Roger Schawinski. <a href='https://kosmos.ch/programm/filmprogramm/die-affAere-meili-ein-whistleblower-zwischen-moral-und-milliarden/113929/nach-film#details'>Weitere Informationen</a>
                    </li>
                    <li>
                      23. August 2018, 20.05 Uhr, Ausstrahlung am Schweizer
                      Fernsehen SRF 1, das den Film koproduziert hat.
                    </li>
                    <li>
                      Und ab sofort als Webstory unter{' '}
                      <a href='https://www.meili-story.ch/'>
                        www.meili-story.ch
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
            <aside
              className='ui right rail computer or lower hidden'
              style={{ top: '160%', left: '70%' }}
            >
              <div className='story-hint'>
                <div className='hint-container'>
                  <strong>
                    «Affäre Meili – Ein Whistleblower zwischen Moral und
                    Milliarden»
                  </strong>
                  <br />
                  Ein brisanter Aktenfund macht aus einem Wachmann einen
                  Whistleblower, aus einem Sonderbotschafter einen TV-Star und
                  reisst ein neutrales Land in eine Staatsaffäre. Der von Daniel
                  von Aarburg realisierte Dokumentarfilm feiert Mitte August
                  Premiere.
                  <ul>
                    <li>
                    16. August 2018, 20 Uhr, Premiere und Debatte gibt es auch kostenlos im Livestream. <a href='https://www.offenerechnungen.ch/events-livestream'>Zur Anmeldung</a>
                    </li>
                    <li>
                      21. August 2018, 19.30 Uhr, Kino Kosmos, Zürich. Anschliessend Streitgespräch mit Christoph Blocher und Jakob Tanner. Moderation: Roger Schawinski. <a href='https://kosmos.ch/programm/filmprogramm/die-affAere-meili-ein-whistleblower-zwischen-moral-und-milliarden/113929/nach-film#details'>Weitere Informationen</a>
                    </li>
                    <li>
                      23. August 2018, 20.05 Uhr, Ausstrahlung am Schweizer
                      Fernsehen SRF 1, das den Film koproduziert hat.
                    </li>
                    <li>
                      Und ab sofort als Webstory unter{' '}
                      <a href='https://www.meili-story.ch/'>
                        www.meili-story.ch
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
            <p>
              So überlegte Christoph Meili, wem er die geretteten Bücher
              anvertrauen sollte. Der tiefgläubige Christ fand, dass sein Fund
              in jüdische Hände gehörte. Er rief die Israelische Botschaft in
              Bern an, wo er vernahm, er könne die Unterlagen per Post schicken.
              Das Porto oder eine Fahrt nach Bern schien ihm zu teuer. Im
              Telefonbuch von Zürich suchte er das Stichwort «Israelitisch».
              Zuoberst fand sich die Israelitische Cultusgemeinde Zürich (ICZ),
              die er anrief. Man sagte ihm, er könne die Papiere gern
              vorbeibringen. Dies tat Meili denn auch umgehend.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349932|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349932/frame-1-349932.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              Christoph Meili wollte mit seiner Entdeckung an die
              Öffentlichkeit, mit vollem Namen. Es wurde ihm die Journalistin
              Gila Blau empfohlen, die Autorin dieses Berichtes, die damals
              bereits regelmässig über die Kontroversen rund um das Thema der
              nachrichtenlosen Vermögen berichtete.
            </p>
            <p>
              Am Sonntag besuchte die Schreibende den Whistleblower und seine
              Familie in ihrem kleinen Reiheneinfamilienhaus. Da sie bereits
              ahnte, was sich entwickeln würde, sobald ihre Geschichte
              erschienen war, brachte sie einen kurzen Vertrag mit. Darin war
              festgehalten, dass die Meilis für das Interview kein Honorar
              erhalten hätten. Die Journalistin fotografierte die Familie für
              ihre Reportage in der Wochenzeitung «Jüdische Rundschau» (heute:
              «Tachles»).
            </p>

            <h4>Zwei Folianten und eine Foto-Ikone</h4>
            <p>
              Am folgenden Montag, die Reportage war bereits an die Redaktion
              abgeschickt, läutete es bei der Schreibenden. Vor ihrer Tür stand
              Christoph Meili, in der Hand einen Papiersack der Migros. Er zog
              zwei schwere Folianten heraus und sagte, auch diese Bücher habe er
              vor dem Schredder retten können: «Ich fand es schade, sie
              vernichten zu lassen.» Meili hatte die beiden zusätzlichen Bände
              in seinem Spind zwischengelagert. Weil er richtig vermutete, dass
              die Geschichte bald öffentlich würde und er keinen Zugang mehr zur
              Bank haben würde, brachte er die beiden Bände nach Dienstschluss
              zur Journalistin, zu der er offenbar Vertrauen gefasst hatte. Die
              Bücher stammten aus dem Ende des 19. Jahrhunderts und enthielten
              handschriftlich die Kreditvergaben der Eidgenössischen Bank (die
              nach dem Zweiten Weltkrieg von der SBG übernommen worden war).
            </p>
            <p>
              Der Schreibenden war bewusst, dass sie einen Beweis brauchte, da
              es sonst eines Tages heissen würde, Meili habe doch gar nichts
              gefunden, er behaupte das nur. Diese beiden Bücher, wenn auch
              nicht aus der relevanten Zeit, waren DER Beweis für seinen Fund.
              Sie benötigte ein Dokument, eine Foto von Meili mit den Büchern.
              So stellte sie ihn vor eine weisse Wand in ihrer Wohnung,
              balancierte mit Mühe die schweren Folianten auf seinen Armen und
              machte zwei Bilder. In Schwarzweiss, denn der Film vom Vortag
              befand sich noch in der Kamera. Für einen Filmwechsel war keine
              Zeit geblieben.
            </p>
            <p>
              Dieses Foto sollte zur Ikone werden. Es gleiche den Abbildungen
              von Moses mit den Gesetzestafeln, hiess es einmal sogar.
              Jedenfalls bedeutet und beweist es die Verbindung von Christoph
              Meili mit den unerlaubt zur Vernichtung freigegebenen Kontobüchern
              aus dem Archiv der Eidgenössischen Bank bei der SBG. Bis heute
              blieb ungeklärt, wieso ein simpler Wachmann Kenntnis vom
              Bundesbeschluss über das Verbot der Aktenvernichtung aus der
              NS-Zeit besass, nicht aber der (mittlerweile verstorbene)
              Chef-Archivar der SBG. Dieser wurde subito suspendiert und auf
              einen gut bezahlten Job bei einer SBG-Filiale in Luzern
              abgeschoben.
            </p>
            <p>
              <a href='https://interaktiv.tagesanzeiger.ch/2018/schweizer-privatagenten/?openincontroller'>
                <img
                  src='https://interaktiv.tagesanzeiger.ch/2018/schweizer-privatagenten/inline-teaser.jpg'
                  style={{ width: '100%' }}
                />
              </a>
            </p>
            <p>
              Anderntags, es war mittlerweile Dienstag, der 14. Januar 1997,
              geschah Ungewöhnliches: Bezirksanwalt Peter Cosandey, früher
              selber bei einer Bank tätig, liess der Bankgesellschaft den
              Vortritt für eine Medienmitteilung: Es habe eine Panne bei
              Archivbeständen gegeben, hiess es darin lapidar, aber der Fall sei
              restlos aufgeklärt. Unmittelbar danach folgte eine für die Bank
              äusserst positiv formulierte Medienmitteilung der Polizei.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349934|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349934/frame-1-349934.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>
          <div className='ui text container'>
            <p>
              Nun reagierte der Präsident der Israelitischen Cultusgemeinde
              Zürich (ICZ), Werner Rom, rasch und richtig: Er lud die Medien für
              den frühen Nachmittag des gleichen Tages zu einer Pressekonferenz
              in die ICZ ein. An der ersten Medienkonferenz seines Lebens sass
              Christoph Meili blutjung und ungelenk auf dem Podium, auf seiner
              einen Seite der ICZ-Präsident und auf der anderen der Zürcher
              Rechtsanwalt Marcel Bosonnet, den die ICZ Christoph Meili zur
              Verfügung stellte. Der Medienaufmarsch war mager, das
              internationale Echo dagegen gewaltig.
            </p>
            <p>
              Einige Wochen lang gaben sich die Medienleute aus aller Welt, von
              der ARD bis «Vanity Fair», im Reiheneinfamilienhaus der Meilis die
              Klinke in die Hand. Christoph Meili war anwesend und hatte Zeit,
              denn er hatte postwendend seinen Job verloren. Und es ging nicht
              lange, da lenkte ihn ein Anruf von seinen Sorgen ab, wie er seine
              Familie in Zukunft ernähren sollte: Der amerikanische Senator
              Alfonse D'Amato, Vorsitzender der Bankenkommission des Senats, lud
              die Familie Meili in die USA ein. Christoph Meili war leider nicht
              davon abzubringen. So begann seine USA-Karriere.
            </p>
            <h4>Druck aus den USA</h4>
            <p>
              In den USA waren die Schweiz und ihre Banken schon im Jahr zuvor
              ins Visier geraten. Angeblich soll alles damit begonnen haben,
              dass Israel Singer, der allmächtige Generalsekretär des Jüdischen
              Weltkongresses und rechte Hand seines Präsidenten Edgar Bronfman
              (der ihn einige Jahre später wegen jahrelanger Veruntreuung
              entliess), den Kriminal-Thriller «The Swiss Account» las. Nach der
              Lektüre soll Singer beschlossen haben, die Schweizer Banken
              müssten alle Vermögenswerte hergeben, die vor dem Krieg jüdische
              Ausländer bei ihnen in Sicherheit gebracht hatten. Viele der
              Konto- und Schliessfach-Inhaber waren im Krieg ermordet worden und
              ihre überlebenden Erben hatten vergeblich versucht, an ihr Geld zu
              kommen. Berüchtigt war die unsensible Forderung nach
              Totenscheinen, die in Vernichtungslagern nicht ausgestellt wurden.
              An der Mauer der Banken kam jedoch niemand vorbei. Negativ bekannt
              wurde SBG-Präsident Robert Studer, der die jüdischen
              Vermögenswerte als «Peanuts» im Vergleich zur Bilanzsumme abtat.
              Immer wieder im Lauf der Jahre war nach nachrichtenlosen Vermögen
              gefragt worden. Aber diesmal erschienen die ersten einschlägigen
              Zeitungsartikel. Der amerikanische Europa- und
              Restitutionsbotschafter Stuart Eizenstat fühlte sich alarmiert
              durch einen Bericht im «Wall Street Journal». Lawinenartig wurde
              in den USA nun Druck auf die Schweiz aufgebaut.
            </p>
            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '50ContentRead'
                  })
                }
              }}
            />
            <h4>Ratloser Bundesrat</h4>
            <p>
              1996 lud die Schweizerische Bankiervereinigung den Jüdischen
              Weltkongress und jüdische Exponenten der Schweiz nach Bern zum
              Mittagessen in ein Nobellokal ein. Es wurde zum Desaster, weil
              Edgar Bronfman nach dem im Stehen eingenommenen Apéro entrüstet
              erzählte, man habe ihm nicht einmal einen Stuhl angeboten.
            </p>
            <p>
              Der Bundesrat beachtete die Warnsignale nicht. Nur Botschafter
              Carlo Jagmetti in Washington erkannte das Wetterleuchten und
              organisierte schon früh ein Treffen zwischen
              Botschaftsangehörigen, Senator Alfonse D'Amato und Bankenanwälten
              in New York. Die Bundesräte unterschätzten den sich
              zusammenbrauenden Sturm. Und sie wussten, so schien es, herzlich
              wenig über die noch nicht so lange zurückliegende Geschichte ihres
              Landes im Zweiten Weltkrieg. Bundesrätin Ruth Dreifuss war es, die
              ihren Kollegen einiges erklären konnte. Aber als Innenministerin
              führte sie das Dossier nicht; es gehörte dem Aussenministerium,
              weil die Musik in den USA spielte.
            </p>
          </div>

          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@351719|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/351719/frame-1-351719.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              Der Aussenminister, Bundesrat Flavio Cotti, reagierte spät. Aber
              dann bestellte er plötzlich seinen stellvertretenden
              Generalsekretär, den jungen Diplomaten Thomas Borer, zum Chef
              einer Taskforce Schweiz - Zweiter Weltkrieg.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349940|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349940/frame-1-349940.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              Das Jahr 1996 endete mit einem weiteren Paukenschlag:
              Bundespräsident Jean-Pascal Delamuraz gab einer Zeitung der
              Romandie ein Interview zum Ende seines Präsidialjahres. Der dem
              Weisswein nicht abgeneigte Waadtländer FDP-Magistrat sprach darin
              von einer Erpressung der Schweiz und machte die gar nicht
              magistrale Aussage, man könnte meinen, Auschwitz liege in der
              Schweiz. Die Wogen der Empörung schlugen hoch. Delamuraz
              entschuldigte sich nicht, nur bei jenen, die er möglicherweise
              verletzt habe.
            </p>
            <p>
              Das Wort Erpressung geisterte in der Folge noch stark durch
              gewisse Kreise im Land. Am lautesten sprach Christoph Blocher
              darüber, der damalige SVP-Nationalrat und spätere Bundesrat, bis
              vor kurzem Chefstratege seiner Partei, die er zur stärksten der
              Schweiz gemacht hatte.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349942|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349942/frame-1-349942.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              Blocher sprach einen Rohrkrepierer an: Die ungeschickt durch
              Bundespräsident Arnold Koller dem Parlament verkündete Idee einer
              Solidaritätsstiftung zugunsten von allerlei Benachteiligten, auch
              Holocaust-Überlebenden, die durch den Verkauf überflüssiger
              Goldreserven der Nationalbank finanziert werden sollte. Das
              Projekt kam nie zustande.
            </p>
            <p>
              Die Taskforce unter Thomas Borers tatkräftiger Leitung hingegen
              nahm bald Formen an und stärkte das Verteidigungsdispositiv der
              Schweiz. Borer war und ist ein genialer Verkäufer, der aus seiner
              Zeit als Jungdiplomat auf der Schweizer Botschaft in Washington
              die amerikanischen Gedankengänge und Sitten bestens kannte.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349944|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349944/frame-1-349944.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              1997 wurde zum «annus horribilis» für die Schweiz, in dem das so
              lange latente Thema zu einer veritablen Staatskrise führte. Das
              Land war gespalten. Die Aktivdienst-Generation war beleidigt und
              wütend. Noch 1989 hatte die Armee ihre Veteranen zu
              Jubiläumsfeiern des Kriegsbeginns (!) eingeladen, was das Land
              weiter polarisiert hatte. Der sogenannte Eizenstat-Bericht wies
              nach, dass die neutrale Schweiz Nazi-Deutschland auf vielen
              Gebieten behilflich und nützlich gewesen war. Die Nationalbank
              hatte das in den besetzten Ländern geraubte Gold der Staatsbanken
              für Nazi-Deutschland willig in existenziell wichtige Devisen
              umgewandelt. Sogar Zahngold aus den Vernichtungslagern war
              übernommen worden. Es gab, erinnerlich, einen einzigen Leserbrief,
              in dem ein älterer Herr aus der Aktivdienst-Generation schrieb, er
              frage sich heute, für wen und was er damals an der Grenze
              gestanden sei.
            </p>

            <h4>Historiker und Gegen-Historiker</h4>
            <p>
              Der Bundesrat blieb, ausser bei der Gründung der Taskforce, stumm.
              Dafür handelte das Parlament. Einstimmig beschloss es, eine
              Unabhängige Experten-Kommission (UEK) Schweiz - Zweiter Weltkrieg
              zu gründen, die aus renommierten in- und ausländischen Historikern
              und ihren Doktoranden als Recherche-Personal bestand. Die Leitung
              erhielt der Waadtländer Jean-François Bergier, Professor an der
              ETH Zürich, ein Mittelalter-Forscher, der der Kommission auch
              seinen Namen gab. Ausserdem wurde unter Leitung des früheren
              Nationalbankchefs der USA, Paul Volcker, ein Bankenausschuss
              gegründet, dem auch jüdische Exponenten angehörten. Dieser
              Untersuchungsausschuss durchleuchtete in der aufwendigsten
              Bankenrevision aller Zeiten forensisch die Archive der Schweizer
              Banken nach versteckten nachrichtenlosen Vermögenswerten. Die
              Kosten in der Höhe von 200 Millionen Franken hatten die
              betroffenen Banken zu tragen. Die Bergier-Kommission dagegen wurde
              durch den Bund finanziert.
            </p>
            <p>
              Die Mitglieder der Bergier-Kommission und ihre Mitarbeitenden
              bekamen das Privileg des unbeschränkten Archivzugangs, was noch
              nie vorgekommen war. Mit ungeheurem Aufwand und unter einigem
              Zeitdruck wurden ein Dutzend Studien und ein Schlussbericht
              innerhalb von fünf Jahren erstellt. Die Rezeption des
              Bergier-Berichts jedoch war sehr kühl. Nicht einmal der Bundesrat
              äusserte sich positiv, obwohl Bundesrätin Ruth Dreifuss ihr
              Kollegium an der Schlusspräsentation im Bundeshaus vertrat und
              eine kurze Stellungnahme abgab. Unter der Hand wurde später
              bekannt, dass Dreifuss in all den Jahren ihre schützende Hand über
              die Kommission gehalten hatte, die von vielen Seiten angegriffen
              wurde. Vor allem durch Christoph Blocher und seine SVP. Blocher
              fand, es sei ja schon alles bekannt über die Geschichte der
              Schweiz im Zweiten Weltkrieg, eine Kommission sei gar nie nötig
              gewesen.
            </p>
            <p>
              Namhafte Historiker und Politiker gründeten eine Gegen-Kommission
              («Aktion Gelebte Geschichte»), andere Historiker waren beleidigt,
              dass sie nicht ins Gremium berufen worden waren, und bemühten
              sich, Recherchen zu publizieren, welche die Schweiz der
              Kriegsjahre in besserem Lichte darstellen sollten. Aber die
              Bergier-Kommission und ihre Erkenntnisse bildeten für die
              gebeutelte Schweiz, die allgemein unter dem Versagen ihrer
              unsensiblen Banken leiden musste, eine Visitenkarte im Ausland,
              die nicht zuletzt auch die Taskforce gut brauchen konnte.
            </p>

            <h4>Die Stimme des Diplomaten</h4>
            <p>
              Stuart Eizenstat diente als Spitzenbeamter mehreren demokratischen
              Präsidenten der Vereinigten Staaten, angefangen bei Jimmy Carter,
              über dessen Präsidentschaft er dieses Jahr ein Buch
              veröffentlichte. 1997 war er unter Bill Clinton US-Botschafter bei
              der EU und zudem beauftragt, enteignetes oder geraubtes jüdisches
              Eigentum in Osteuropa wiederzubeschaffen. In dieser Funktion
              kümmerte er sich auch um die Problematik der nachrichtenlosen
              Vermögen auf Schweizer Banken. Der Diplomat konnte nicht
              verstehen, dass er nicht wie gewohnt mit einer Regierung zu
              verhandeln hatte. Er empfand es zunehmend als Problem, dass sich
              der Bundesrat stur ausklinkte. Im Mai 1997 erschien sein Bericht
              zum Goldhandel der Nazis mit den neutralen Staaten. Im Vorwort des
              Berichts, in dessen Mittelpunkt der Bankenplatz Schweiz als
              wichtigster Abnehmer von Nazi-Gold stand, warf Eizenstat der
              Schweiz implizit und explizit vor, sie habe durch ihre
              Kollaboration mit Nazi-Deutschland den Krieg erheblich verlängert.
              Die Schweizer Öffentlichkeit reagierte empört auf diesen Vorwurf.
              Antisemitismus machte sich breit. Auch die Bergier-Kommission
              bestätigte den pauschalen Kriegsverlängerungsvorwurf nicht.
              Eizenstat selbst entschuldigt sich heute dafür.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@351727|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/351727/frame-1-351727.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              In die aufgeladene Stimmung des Eizenstat-Berichts platzte als
              Eskalation die Meili-Affäre und goss weiter Öl ins Feuer. So sieht
              es auch Eizenstat.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@351729|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/351729/frame-1-351729.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              Es erschienen bald auch verschiedene andere Publikationen zum
              Thema, nicht zuletzt eine von Jean Ziegler. Ihre Titel drehten
              sich immer um «Die Schweiz, das Gold und die Juden». Auch in der
              Schweiz gab es eine Menge Zeitungsartikel und Talkshows. In einer
              «Arena»-Sendung des Schweizer Fernsehens behauptete der Chef der
              Bankgesellschaft, Robert Studer, er wisse, dass Meili nicht allein
              aus ethischen Motiven gehandelt habe. Damit unterstützte er die
              bösartige Unterstellung, dass Christoph Meili «von den Juden» Geld
              erhalten hatte, um seine Tat zu vollbringen, ohne diese Absurdität
              je belegen zu können.
            </p>
            <p>
              Die Schweizer Banken standen mittlerweile in den USA schwer unter
              Druck. Verschiedene Bundesstaaten drohten mit dem Entzug der
              Lizenz für die USA-Filialen. Das Thema der vorenthaltenen
              nachrichtenlosen Vermögenswerte und die Meili-Affäre veranlassten
              die neue Bankengeneration nie zu einer Entschuldigung für frühere
              Versäumnisse. Das war, wie später Alex Krauer, Interims-Präsident
              der UBS, in einer «Arena» sagte, lediglich «ein
              Management-Problem». Keine Spur von moralischer Verantwortung.
            </p>
            <p>
              In den USA veranstaltete der republikanische Senator Alfonse
              D'Amato aus New York Hearings vor seiner Bankenkommission des
              Senats. Er lud allerlei Exponenten vor, auch den Zürcher Bankier
              Hans Bär, die Überlebende Greta Beer, die bei Schweizer Banken
              vergeblich die Konten ihres Vaters gesucht hatte, den Jüdischen
              Weltkongress sowie auch Taskforce-Chef Thomas Borer. In der
              Schweiz gab es böse Zungen, die behaupteten, D'Amato mache dies
              nicht aus moralischer Überzeugung, sondern um die jüdischen
              Stimmen in New York für seine Wiederwahl zu gewinnen (die ihm dann
              aber misslang). Er verneint diese Motivation bis heute.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@351731|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/351731/frame-1-351731.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>

          <div className='ui text container'>
            <p>
              An ein Hearing der konkurrierenden Bankenkommission des
              Repräsentantenhauses unter James Leach wurde auf Initiative der
              Schreibenden auch der damalige Präsident des Schweizerischen
              Israelitischen Gemeindebundes, der Berner Unternehmer Rolf Bloch,
              eingeladen. Bloch, der auch in der Volcker-Kommission stets die
              Wogen glättete, prägte im Hearing den vielzitierten Satz:
              «Gerechtigkeit für die Juden und Fairness für die Schweiz.» Bloch
              wurde später auch Präsident des Schweizerischen Fonds für
              Überlebende von Holocaust und Schoa, gespeist durch je 100
              Millionen Franken der Grossbanken und der Nationalbank. Bloch
              bestand darauf, dass alle Kategorien von Verfolgten – auch
              nichtjüdische – eine Geldsumme erhalten sollten. Er bewältigte
              diese Titanen-Aufgabe mit dem Bonmot: «Ich habe nicht gewusst,
              dass es so schwer sein könnte, Geld auszugeben.»
            </p>

            <h4>Als Held verehrt, als Köder missbraucht</h4>
            <p>
              In der Zwischenzeit hatte für Christoph Meili in der Schweiz der
              Wind gedreht. Aus einem Whistleblower mit Zivilcourage war innert
              weniger Wochen ein Nestbeschmutzer geworden. Meili wurde
              beschimpft und bedroht. Einen neuen Job bekam er nicht. So
              entschied er sich Ende 1997, mit seiner Familie in die USA
              auszuwandern. Trotz aller Warnungen, er werde dort nur ausgenützt
              und dann fallen gelassen. Im Ausland war er nun ein Held, eine
              Lichtgestalt. Es gab Einladungen nach Israel, und in den USA trat
              er an Versammlungen von jüdischen Organisationen auf und diente
              zugleich als Lockvogel für Spenden. In Kalifornien bekam er ein
              Stipendium für ein Studium an der Chapman University und ein Haus
              zur Verfügung gestellt, für das er allerdings Miete zahlen musste.
              Vom vielen Geld, das er für andere generierte, sah er wenig bis
              nichts.
            </p>

            <h4>Verhandlungen und ein Vergleich</h4>
            <p>
              Als die Verhandlungen zu einem aussergerichtlichen Vergleich
              zwischen den jüdischen Sammelklägern und den Schweizer Banken
              begannen, wurde Christoph Meili eine Million Dollar versprochen.
              Die Klagen waren beim New Yorker Bezirksrichter Edward Korman
              deponiert worden. Als die Verhandlungen zu scheitern drohten,
              zitierte Jugde Korman alle Kontrahenten am 11. August 1998 in ein
              mittlerweile geschlossenes Restaurant in Brooklyn und zimmerte im
              letzten Moment einen Vergleich über 1,25 Milliarden Dollar. In
              diesem wurde per Saldo aller Ansprüche vereinbart, dass nicht nur
              die Banken, sondern auch die Schweizer Industrie und die
              Eidgenossenschaft für alle Zeiten aus dem Schneider waren. Diesen
              sogenannt «globalen Vergleich» verkündete niemand anderer als
              Alfonse D'Amato medienwirksam auf offener Strasse, neben sich das
              Ehepaar Meili und Israel Singer vom Jüdischen Weltkongress.
            </p>

            <h4>Zurück in die Schweiz</h4>
            <p>
              Christoph Meili durchlebte in den USA nach vielen Hochs noch mehr
              Tiefs: Seine Ehe zerbrach, er verlor Frau und Kinder. Nach Abzug
              von Anwaltskosten und Scheidung blieben ihm von der versprochenen
              Million noch 265’000 Dollar. Er jobbte, auch als Wachmann. Danach
              ging er zur Armee, denn schliesslich besass er das amerikanische
              Bürgerrecht. Er heiratete eine Frau mit koreanischen Wurzeln,
              hatte mit ihr einen Sohn, doch auch diese Ehe scheiterte.
            </p>
            <p>
              Nach 12 Jahren in den USA kam Christoph Meili 2009 allein und
              mittellos in die Schweiz zurück. Nach vielen Schwierigkeiten
              scheint er heute seinen Frieden gefunden zu haben. Nicht zuletzt
              dank seiner dritten Gattin Nadja, die der noch immer tiefgläubige
              evangelikale Christ in einer Freikirche kennen lernte. Eine feste
              Anstellung konnte Meili allerdings bis heute nirgends bekommen. Im
              April 2018 wurde er 50 Jahre alt und hat die Vergangenheit recht
              gut loslassen können, auch wenn diese ihn nicht restlos loslässt.
              Immer noch wird er, wird sein Name erkannt, aber meist sind die
              Reaktionen sehr positiv.
            </p>
            <p>
              Der frühere Wachmann würde alles nochmals so machen, wenn auch
              ganz leicht anders. Meili denkt, dass er nicht in die USA hätte
              auswandern sollen, obwohl seine Kinder dort unbelastet zur Schule
              gehen konnten. Er pflegt mit seinen inzwischen erwachsenen
              Sprösslingen mittlerweile wieder einen guten Kontakt. Insgesamt
              bereue er aber gar nichts. Er tat das Richtige, denkt er, und was
              daraus wurde, konnte er nicht allein beeinflussen.
            </p>
          </div>
          <div className='ui bigscreen container'>
            <div className='videoWrapper'>
              <iframe
                className='externalNNIFrame'
                src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@349952|showLogo@1|autoStart@0|mute@0|showAds@false|previewPath@http://server025.newsnetz.tv/349952/frame-1-349952.jpg|platform@desktop'
                allowFullScreen='true'
                scrolling='no'
                frameBorder='no'
              />
            </div>
            <figcaption className='ui container ta caption'>
              Aus Dok-FIlm «Affäre Meili – Ein Whistleblower zwischen Moral und
              Milliarden»,{' '}
              <a href='https://www.meili-story.ch/'>www.meili-story.ch</a>
            </figcaption>
          </div>
          <p className='spaced'>&nbsp;</p>
        </div>

        {/* Waypoint */}
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />

        {/* Chapter 2 */}
        <main className='ui vertical very fitted segment interview'>
          <div className='ui text container' style={{ marginTop: '1em' }}>
            <p className='spaced'>&nbsp;</p>
            <h4>Die Autorin</h4>
            <p>
              Journalistin Gila Blau beschäftigte sich in ihren Recherchen
              intensiv mit der Thematik der Schweiz im Zweiten Weltkrieg. Die
              Israelitische Cultusgemeinde Zürich vermittelte ihr deshalb im
              Januar 1997 den Kontakt zu Whistleblower Christoph Meili, der mit
              seinem brisanten Aktenfund an die Öffentlichkeit wollte. Danach
              schrieb sie erst für die «Jüdische Rundschau» eine Reportage über
              Meili und später auch für andere Publikationen. Sie steht Meili
              seit mehr als 20 Jahren kritisch, aber freundschaftlich als eine
              Art private Medienberaterin zur Seite. Ihr persönliches Archiv
              über den Fall Christoph Meili und die gesamte Staatskrise der
              späten Neunzigerjahre umfasst mehrere Laufmeter an Akten und
              Artikeln. Sie überliess ihre Dokumentation vor ein paar Jahren für
              Forschungszwecke dem Archiv für Zeitgeschichte der ETH Zürich.
            </p>
            <p className='spaced'>&nbsp;</p>
          </div>
        </main>

        {/* footer */}
        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='center aligned row teaser-section'>
                <a href='/'>
                  <img
                    src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
                    className='portfolio-teaser'
                  />
                </a>
              </div>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Idee, Recherche und Text</td>
                        <td>
                          Docmine, Gila Blau, Daniel von Aarburg, Moira Rehsche
                        </td>
                      </tr>
                      <tr>
                        <td>Digitales Konzept, Umsetzung</td>
                        <td>Mathias Lutz, Interaktiv-Team</td>
                      </tr>
                      <tr>
                        <td>Videos</td>
                        <td>
                          <a href='http://www.docmine.com/' target='_blank'>
                            Docmine
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Veröffentlicht</td>
                        <td>
                          <TimestampFormatter timestamp={1534042920} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage mailTo='interaktiv@tages-anzeiger.ch' />
                  <div className='ui fluid share aligned container'>
                    <ShareButtons
                      articleID={this.props.articleId}
                      hashtags={['TAGrafik', 'ddj']}
                      displayType={displayTypes.VERTICAL_BUTTONS}
                    />
                  </div>
                </div>
                <div className='column'>
                  <div className='ui fluid copyright container'>
                    <PolymorphicCopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>

        {/* Waypoint */}
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)



// WEBPACK FOOTER //
// ./src/components/main/index.js